import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from '../stores/UserStore'
import { useUserPresencial } from '../stores/UserPresencial'
import { ApiUrl, Headers } from '../services/ApiUrl';
import axios from 'axios'
import ShareOnSocial from "react-share-on-social";
import { Modal, Container, Row, Col, Button, ListGroup, Badge, Spinner } from 'react-bootstrap';
import ProyectosHomeCard from './ProyectosHomeCard';
import ModalVotarPropuesta from './VotarModal';
import UserWelcome from './UserWelcomeVotar';
import VoterForm from './VoterFormPresencial';
import { useUserAdminPresencial } from '../stores/UserAdminPresencial';
import VideoYoutube from './VideoYoutube';
import { useSystemOptionsStore } from '../stores/useOptions';
import { useUserAdminStore } from '../stores/userAdmin'


const ProyectosHome = () => {
  const [proyectosPP2023, setProyectosPP2023] = useState([])
  const [loadingPP2023, setLoadingPP2023] = useState(false)
  const [showID, setShowID] = useState(0)
  const [disabledButtonVotar, setDisabledButtonVotar] = useState(false)
  const [idPropuestaVotar, setIdPropuestaVotar] = useState(0)
  const [titlePropuestaVotar, setTitlePropuestaVotar] = useState(0)
  const [showModalVotar, setShowModalVotar] = useState(false);
  const [show, setShow] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const userGlobal = useUserStore((state) => state.userGlobal)
  const userPresencial = useUserPresencial((state) => state.userPresencial)
  const updateUser = useUserStore((state) => state.updateUser)
  const updateUserPresencial = useUserPresencial((state) => state.updateUserPresencial)
  const closeUser = useUserStore((state) => state.closeUser)
  const userAdminPresencial = useUserAdminPresencial((state) => state.userAdminPresencial)
  const userAdmin = useUserAdminStore((state) => state.userAdmin)

  const { systemOptions } = useSystemOptionsStore();

  useEffect(() => {
    const votacionInactiva = systemOptions.votacionActiva === 0;

    // Si no hay ningún usuario logueado (ni global ni presencial), el botón debe estar deshabilitado
    const noHayUsuarioLogueado = !userGlobal.login && !userPresencial.login;

    const nuevoEstado =
      votacionInactiva ||                                         // Si la votación está inactiva
      noHayUsuarioLogueado ||                                    // O si no hay usuario logueado
      userGlobal.isVoted ||                                      // O si el usuario ya votó
      userPresencial.isVoted ||                                  // O si el usuario presencial ya votó
      (!userPresencial.login && userAdminPresencial.login === true);  // O si es admin presencial sin login de usuario

    // Si es un admin logueado, el botón siempre estará activo para pruebas
    if (userAdmin.login) {
      setDisabledButtonVotar(false);
      return;
    }

    setDisabledButtonVotar(nuevoEstado);
  }, [
    systemOptions.votacionActiva,
    userGlobal.login,
    userGlobal.isVoted,
    userPresencial.login,
    userPresencial.isVoted,
    userAdminPresencial.login,
    userAdmin.login
  ]);

  const handleCloseModalVotar = () => setShowModalVotar(false);

  const handleVote = async (idProyecto) => {
    let codigo_confirma_sesion = 0;
    let id_sesion = 0;
    let voto_presencial = 0;
    let id_user = 0; // Inicializamos id_user en 0 por defecto

    if (userGlobal.login) {
      codigo_confirma_sesion = userGlobal.codigo_confirm;
      id_sesion = userGlobal.id_user;
      voto_presencial = 0;
      // Para userGlobal, id_user queda en 0
    }
    if (userPresencial.login) {
      codigo_confirma_sesion = userPresencial.codigo_confirm;
      id_sesion = userPresencial.id_user;
      voto_presencial = 1;
      id_user = userAdminPresencial.id_user; // Solo asignamos id_user si es presencial
    }



    const formData = {
      id_votante: id_sesion,
      id_proyecto: idProyecto,
      codigo_confirm: codigo_confirma_sesion,
      voto_presencial: voto_presencial,
      id_user: id_user // Agregamos el nuevo campo al formData
    };

    try {
      const url = `${ApiUrl}votarproyecto`;
      const response = await axios.post(url, formData, { headers: Headers });

      if (response.status === 200) {
        if (voto_presencial === 1) {
          updateUserPresencial({ ...userPresencial, isVoted: true });
        } else {
          updateUser({ ...userGlobal, isVoted: true });
        }
        setShowSuccessModal(true);
        // TODO: Actualizar el store de zustand
        // useStore.getState().setUserVoted(true);
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error al procesar el voto');
      setShowErrorModal(true);
    }
  };

  const handleRegister = () => {
    // Lógica para manejar el registro
    //console.log('Redirigiendo a la página de registro');
  };

  const handleClose = () => {
    window.history.pushState({}, null, "/pp/propuestas/");
    setShow(false)
  }
  const handleShow = () => {
    setShow(true)
  }

  const cargarProyectosPP2023 = () => {
    // PP GENERAL 2023
    setLoadingPP2023(true)
    //let url = ApiUrl + 'relations?rel=users_proyectos,pp2023_proyectos_aprobados&type=,user&select=*&linkTo=categoria_proyecto&equalTo=PP General 2023&linkTo=localidad&equalTo=Beruti'
    let url = ApiUrl + 'pp2023_proyectos_aprobados?select=*'
    axios.get(url, { headers: Headers })
      .then(response => {
        setProyectosPP2023(response.data.results.filter(proyectos => (proyectos.id_user !== "1")))
      }).catch(error => {
        setProyectosPP2023([])
      })
      .finally(function () {
        setLoadingPP2023(false)
      });
  }

  const cambiarUrl = (id_proyecto) => {
    setShow(true)
    setShowID(id_proyecto)
    window.history.pushState({}, null, `/pp2023/propuestas/${id_proyecto}`);
  }


  const navigate = useNavigate();
  const navegarTo = (destino) => {
    const destinourl = '/propuestas/' + destino;
    navigate(destinourl);
  }

  const navegarToVotar = (destino) => {
    // SINO inició sesion va a esa pagina
    const destinourl = '/votarpropuestas/';
    navigate(destinourl);
  }

  const votarPropuesta = (id_propuesta) => {
    // mostraría un modal de confirmar si el usuario inició sesión
    // o un modal informando que para votar debe iniciar sesion y un boton para registrarse
    // Verificar si hay un usuario logueado antes de mostrar el modal
    if (!userGlobal.login && !userPresencial.login) {
      // Redirigir a la página de login o mostrar un modal de error
      navegarToVotar();
      return;
    }

    setIdPropuestaVotar(id_propuesta)
    const filtertitlePropuestaVotar = proyectosPP2023?.find(proyecto => proyecto.id_proyecto === id_propuesta)?.titulo_proyecto || '';
    setTitlePropuestaVotar(filtertitlePropuestaVotar)
    setShowModalVotar(true);

  }

  const navegarToPropuestas = (destino) => {
    document.getElementById('propuestas').scrollIntoView({ behavior: 'smooth' })
  }

  const handleLogout = () => {
    // Aquí iría la lógica para cerrar sesión
    // Por ejemplo, podrías resetear el userData o llamar a una API
    closeUser()
    //console.log("Sesión cerrada");
  };

  useEffect(() => {
    cargarProyectosPP2023()
  }, []);

  return (
    <>

      <div className="container-fluid py-5" style={{
        background: 'linear-gradient(135deg, #0A4D2E 0%, #E91E63 100%)',
        boxShadow: 'inset 0 0 100px rgba(0,0,0,0.2)'
      }}>
        <div className="container py-5">
          <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
            <div className="col-10 col-sm-8 col-lg-6">
              <div className="d-flex justify-content-center align-items-center h-100">
                <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/voto-online.jpg" className="img-fluid" alt="PP23 Logo" style={{ marginRight: '1rem' }} />

              </div>
            </div>
            <div className="col-lg-6">
              <h1 className="display-5 fw-bold text-white lh-1 mb-3" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>Propuestas del Presupuesto participativo</h1>
              <p className="lead text-light" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                Acá vas a encontrar todas las propuestas que cumplieron con los requisitos de la Ordenanza Nº 5306/2022 y el apto técnico y presupuestario para poder formar parte y que puedan ser analizados y elegidos por la comunidad. <br />


              </p>
              <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                <button
                  type="button"
                  onClick={navegarToVotar}
                  className="btn btn-light btn-lg px-4 me-md-2 fw-bold"
                  style={{ color: '#E91E63' }}
                  disabled
                >
                  {(userGlobal.login || userPresencial.login) ? (
                    <>Ya iniciaste sesión <i className="bi bi-check-circle-fill"></i></>
                  ) : (
                    <>Iniciar sesión para votar</>
                  )}
                </button>
                <button
                  type="button"
                  onClick={navegarToPropuestas}
                  className="btn btn-outline-light btn-lg px-4"
                  style={{ borderWidth: '2px' }}
                >
                  Ver todas las propuestas
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {userAdminPresencial.login &&
        <VoterForm />
      }

      {userGlobal.login &&

        <Container style={{ marginTop: '30px' }}>
          <Row>
            <Col>
              <UserWelcome
                userData={userGlobal}
                onLogout={handleLogout}
              />
            </Col>
          </Row>
        </Container>

      }






      <Container style={{ marginTop: '30px' }}>
        <Row style={{ marginLeft: '10px', marginRight: '10px' }}>
          <Col>
            <h1>¿Cómo votar?</h1>
            <p style={{ fontSize: '18px', lineHeight: '24px' }}>
              Para elegir entre las propuestas, vas a poder votar de forma online desde el lunes 11 de noviembre a partir de las 7:00 de la mañana hasta el viernes 15 de noviembre de 2024 hasta las 13:00.<br />
              También vas a poder votar de forma presencial en las mesas que estarán dispuestas en tres puntos del distrito:
              <ul style={{ marginTop: '20px' }}>
                <li>En el hall central del Palacio Municipal en la ciudad de Trenque Lauquen</li>
                <li>En las oficinas del Ente Descentralizado de 30 de Agosto</li>
                <li>En las oficinas de la Delegación de Beruti.</li>
              </ul>
              <p>En todos los casos, de manera presencial, de 7:00 a 13:00 desde el lunes 11 de noviembre al viernes 15 de noviembre.</p>

              <p>La ejecución de las propuestas ganadoras se hará con fondos propios de la Municipalidad; y resultarán ganadores:</p>
              <ul>
                <li>3 (tres) proyectos de la localidad de Trenque Lauquen</li>
                <li>1 (uno) de la localidad de 30 de Agosto</li>
                <li>1 (uno) de la localidad de Beruti</li>
                <li>2 (dos) del Presupuesto Participativo Joven</li>
              </ul>
              <p>Las propuestas que no resulten ganadoras quedarán en el Banco de Proyectos para ser evaluadas su ejecución en años sucesivos.</p>

            </p>
          </Col>
        </Row>
      </Container>

      <div id='propuestas'>

      </div>

      {loadingPP2023 &&
        <Container style={{ marginTop: '30px' }}>
          <Row>
            <Col>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
              <span style={{ fontSize: '20px' }}> Cargando las propuestas... </span>
            </Col>
          </Row>
        </Container>
      }

      {/* TRENQUE LAUQUEN */}
      {!loadingPP2023 &&
        <Container style={{ marginTop: '30px' }}>
          <Row style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Col>
              <h2>PP General - Trenque Lauquen</h2>
            </Col>
          </Row>
          {proyectosPP2023
            ?.filter(proyectos => (proyectos.categoria_proyecto === "PP General 2023" && proyectos.localidad_proyecto === "Trenque Lauquen"))
            .map(proyectoPP => (
              <ProyectosHomeCard
                key={`tl-${proyectoPP.id_proyecto}`}
                id_proyecto={proyectoPP.id_proyecto}
                titulo_proyecto={proyectoPP.titulo_proyecto}
                descripcion_proyecto={proyectoPP.descripcion_proyecto}
                tipo_proyecto={proyectoPP.tipo_proyecto}
                nombre_grupo={proyectoPP.nombre_grupo}
                setShowID={setShowID}
                setShow={setShow}
                disabledButtonVotar={disabledButtonVotar}
                votarPropuesta={votarPropuesta}
                video_youtube={proyectoPP.video_youtube}
              />
            ))
          }
        </Container>
      }

      {/* Beruti */}
      {!loadingPP2023 &&
        <Container style={{ marginTop: '30px' }}>
          <Row style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Col>
              <h2>PP General - Beruti</h2>
            </Col>
          </Row>
          {proyectosPP2023
            ?.filter(proyectos => (proyectos.categoria_proyecto === "PP General 2023" && proyectos.localidad_proyecto === "Beruti"))
            .map(proyectoPP => (
              <ProyectosHomeCard
                key={`be-${proyectoPP.id_proyecto}`}
                id_proyecto={proyectoPP.id_proyecto}
                titulo_proyecto={proyectoPP.titulo_proyecto}
                descripcion_proyecto={proyectoPP.descripcion_proyecto}
                tipo_proyecto={proyectoPP.tipo_proyecto}
                nombre_grupo={proyectoPP.nombre_grupo}
                setShowID={setShowID}
                setShow={setShow}
                disabledButtonVotar={disabledButtonVotar}
                votarPropuesta={votarPropuesta}
                video_youtube={proyectoPP.video_youtube}
              />
            ))
          }
        </Container>
      }

      {/* 30 de Agosto */}
      {!loadingPP2023 &&
        <Container style={{ marginTop: '30px' }}>
          <Row style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Col>
              <h2>PP General - 30 de Agosto</h2>
            </Col>
          </Row>
          {proyectosPP2023
            ?.filter(proyectos => (proyectos.categoria_proyecto === "PP General 2023" && proyectos.localidad_proyecto === "30 de Agosto"))
            .map(proyectoPP => (
              <ProyectosHomeCard
                key={`30a-${proyectoPP.id_proyecto}`}
                id_proyecto={proyectoPP.id_proyecto}
                titulo_proyecto={proyectoPP.titulo_proyecto}
                descripcion_proyecto={proyectoPP.descripcion_proyecto}
                tipo_proyecto={proyectoPP.tipo_proyecto}
                nombre_grupo={proyectoPP.nombre_grupo}
                setShowID={setShowID}
                setShow={setShow}
                disabledButtonVotar={disabledButtonVotar}
                votarPropuesta={votarPropuesta}
                video_youtube={proyectoPP.video_youtube}
              />
            ))
          }
        </Container>
      }

      {/* PP JPOVEN 2023 */}
      {!loadingPP2023 &&
        <Container style={{ marginTop: '30px' }}>
          <Row style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Col>
              <h2>PP Joven</h2>
            </Col>
          </Row>
          {proyectosPP2023
            ?.filter(proyectos => (proyectos.categoria_proyecto === "PP Joven 2023" && proyectos.localidad_proyecto === "Trenque Lauquen"))
            .map(proyectoPP => (
              <ProyectosHomeCard
                key={`joven-${proyectoPP.id_proyecto}`}
                id_proyecto={proyectoPP.id_proyecto}
                titulo_proyecto={proyectoPP.titulo_proyecto}
                descripcion_proyecto={proyectoPP.descripcion_proyecto}
                tipo_proyecto={proyectoPP.tipo_proyecto}
                nombre_grupo={proyectoPP.nombre_grupo}
                setShowID={setShowID}
                setShow={setShow}
                disabledButtonVotar={disabledButtonVotar}
                votarPropuesta={votarPropuesta}
                video_youtube={proyectoPP.video_youtube}
              />
            ))
          }
        </Container>
      }


      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        keyboard={true}
        centered
      >
        {proyectosPP2023
          ?.filter(proyectos => proyectos.id_proyecto === showID)
          .map(proyectoPP => (
            <React.Fragment key={proyectoPP.id_proyecto}>
              <Modal.Header closeButton>
                <Modal.Title style={{ textWrap: 'balance' }}>
                  Propuesta #{proyectoPP.id_proyecto} | {proyectoPP.titulo_proyecto}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Badge bg="success">Propuesta Factible</Badge>
                <hr />
                <div style={{ fontSize: '18px' }}>
                  <i className="bi bi-bookmarks"></i> Categoría: {proyectoPP.categoria_proyecto}<br />
                  <i className="bi bi-geo-alt-fill"></i> Localidad: {proyectoPP.localidad_proyecto}
                </div>
                <hr />
                <p><strong>Autores del proyecto:</strong> {proyectoPP.autores_proyecto}</p>
                <p><strong>Descripción del proyecto:</strong> {proyectoPP.descripcion_proyecto}</p>
                <p><strong>Localización:</strong> {proyectoPP.localizacion}</p>
                <ListGroup style={{ fontSize: '16px', marginBottom: '20px' }}>
                  <ListGroup.Item><i className="bi bi-lightbulb icon-grey"></i> Tipo de proyecto: <strong>{proyectoPP.tipo_proyecto}</strong> </ListGroup.Item>
                  <ListGroup.Item><i className="bi bi-people-fill icon-grey"></i> Nombre del grupo: <strong>{proyectoPP.nombre_grupo}</strong> </ListGroup.Item>
                  <ListGroup.Item><i className="bi bi-person-vcard icon-grey"></i> Avales: <strong>{proyectoPP.avales_proyecto}</strong> </ListGroup.Item>
                </ListGroup>

                {proyectoPP.video_youtube !== "" &&
                  <VideoYoutube url={proyectoPP.video_youtube} />
                }
              </Modal.Body>
              <Modal.Footer>
                <ShareOnSocial
                  textToShare="Te comparto esta propuesta del Presupuesto Participativo de la Municipalidad de Trenque Lauquen"
                  link={`https://trenquelauquen.gov.ar/pp/propuestas/${proyectoPP.id_proyecto}`}
                  linkTitle="Presupuesto Participativo"
                  linkMetaDesc="Propuesta del Presupuesto Participativo de la Municipalidad de Trenque Lauquen"
                  noReferer
                >
                  <Button variant="success"><i className="bi bi-share-fill"></i> Compartir la propuesta</Button>
                </ShareOnSocial>
              </Modal.Footer>
            </React.Fragment>
          ))}
      </Modal>


      <ModalVotarPropuesta
        idProyecto={idPropuestaVotar}
        tituloPropuestaVotar={titlePropuestaVotar}
        isLoggedIn={userGlobal.login || userPresencial.login}
        onVote={handleVote}
        navegarToVotar={navegarToVotar}
        showModalVotar={showModalVotar}
        handleCloseModalVotar={handleCloseModalVotar}
      />


      {/* Modal de Éxito */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>¡Voto Registrado!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Gracias por participar. Tu voto ha sido registrado correctamente.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Error */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>



    </>
  )
}

export default ProyectosHome